import { render, staticRenderFns } from "./CustomLayout.vue?vue&type=template&id=74f678ab&scoped=true"
import script from "./CustomLayout.vue?vue&type=script&lang=ts"
export * from "./CustomLayout.vue?vue&type=script&lang=ts"
import style0 from "./CustomLayout.vue?vue&type=style&index=0&id=74f678ab&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f678ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74f678ab')) {
      api.createRecord('74f678ab', component.options)
    } else {
      api.reload('74f678ab', component.options)
    }
    module.hot.accept("./CustomLayout.vue?vue&type=template&id=74f678ab&scoped=true", function () {
      api.rerender('74f678ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomLayout.vue"
export default component.exports